import React, { useState } from 'react';
import { MobileSheet } from 'components/MobileSheet/MobileSheet';
import type { TradeThreadContext } from 'types/interfaces/thread';
import { ContextRail } from './ContextRail';

interface Props {
  conversationId: string;
  viewerUsername?: string;
  onClose: () => void;
  onSummon?: (trade: TradeThreadContext) => void;
}

/**
 * Mobile screen 3 (Decision 13): the context rail as a bottom sheet, top
 * offset 96px, radius 16 16 0 0, grabber, the same sections as the desktop
 * rail, with the action buttons pinned in the sheet footer. Summon Admin lives
 * only here on mobile.
 */
export const ContextSheet: React.FC<Props> = ({ conversationId, viewerUsername, onClose, onSummon }) => {
  const [footerEl, setFooterEl] = useState<HTMLDivElement | null>(null);
  return (
    <MobileSheet
      ariaLabel="Thread details"
      onClose={onClose}
      variant="tall"
      footer={<div ref={setFooterEl} className="context-sheet-actions" />}
    >
      <ContextRail
        conversationId={conversationId}
        viewerUsername={viewerUsername}
        onSummon={onSummon}
        actionsPortalTarget={footerEl}
      />
    </MobileSheet>
  );
};

export default ContextSheet;
